'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('../styles/Pill.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pill = function Pill(_ref) {
  var className = _ref.className,
      children = _ref.children,
      url = _ref.url,
      _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active,
      handleClick = _ref.handleClick;

  var classNames = (0, _classnames2.default)('cp-pill', { active: active }, className);

  if (url && !active) {
    return _react2.default.createElement(
      'a',
      { href: url, onClick: handleClick, className: classNames },
      children
    );
  }
  return _react2.default.createElement(
    'div',
    { className: classNames },
    children
  );
};

Pill.propTypes = {
  className: _react.PropTypes.string,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
  handleClick: _react.PropTypes.func,
  url: _react.PropTypes.string,
  active: _react.PropTypes.bool
};

exports.default = Pill;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/Pill.component.js
// module id = 991
// module chunks = 9